import { useRef } from 'react';
import { Space, Table, Tag, Button,Input,message,Empty,Switch } from 'antd';
import type { TableProps } from 'antd';
import { DataType,column } from '@/pages/account/column';
import { customerServiceList,changeCustomerService } from "@/services/customerService"
import { ResDataType } from "@/services/ajax"
import dayjs from 'dayjs';
import useSearchTable from '@/hooks/useList';
import CusContent from '@/pages/account/component/accountContent';
import MerchantList from '@/pages/account/component/merchantList';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function CustomServicePage() {
  const { menuId } = useGetCurMenuId();
  const dialog = useRef<any>(null);
  const merchant = useRef<any>(null);
  const defaultValue = {
    UserName: '',
    Mobile: '',
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(customerServiceList, defaultValue );
  
  const search = (e:any,field:string)=>{
    handleSearch({[field]: e.target.value})
  }

  const handleChangeStatus = async (id:number,disable:boolean) => {
    const res = await changeCustomerService({id,disable}) as ResDataType;
    if (res.code!= 0) {
      message.error(res.message);
      return;
    }
    handleSearch();
  }

  
  const columns: TableProps<DataType>['columns'] = [
    ...column,
    {
      title:'状态',
      key:'disable',
      render: (_, row) => (
        <Tag color={row.disable ? 'red' : 'green'}>{row.disable ? '禁用' : '启用'}</Tag>
      ),
    },
    {
      title: '注册/上次登录',
      key: 'registerAndLogin',
      render: (_, row) => (
        <>
          <p>注册：{row.registerTime && dayjs(row.registerTime).format("YYYY-MM-DD HH:mm:ss")}</p>
          <p>登录：{row.latestLoginTime && dayjs(row.latestLoginTime).format("YYYY-MM-DD HH:mm:ss")}</p>
        </>
      ),
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
          <MenuPermissionControl menuId={menuId} operation="edit" >
            <Space size="middle">
            <Button onClick={()=>{
              dialog.current.open('edit',record)
            }}>编辑</Button>
            <Button onClick={()=>{
              merchant.current.open(record.id)
            }}>关联商户</Button>
            <Switch checkedChildren="已启用" unCheckedChildren="已禁用" onChange={(e)=>{
              handleChangeStatus(record.id,!record.disable)
            }} checked={!record.disable ? true : false}  />
            </Space>
           </MenuPermissionControl>
      ),
    }
  ];


  return (
    <>
      
      <div className="headerTitle">
        <div>
          <h2 >客服管理</h2>
        </div>
        
      </div>

      <div className="card">
        <div className="mb-4 flex flex-col md:flex-row gap-4">
          <div className="searchCond">
            <Space size='middle'>
            <Input style={{ width:'250px' }} allowClear placeholder="用户名" onPressEnter={(e)=> search(e,'UserName') } size='large' onChange={(e) => search(e,'UserName')}/>
              <Input style={{ width:'250px' }} allowClear placeholder="手机号" onPressEnter={(e)=> search(e,'Mobile') } size='large' onChange={(e) => search(e,'Mobile')}/>
              <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
              <MenuPermissionControl menuId={menuId} operation="edit" >
                <Button type='primary' size='large' onClick={()=>{
                  dialog.current.open('add')          
                }}>新增客服</Button>
              </MenuPermissionControl>
            </Space>
          </div>
        </div>
            
        <Table<DataType>
          rowKey='id'
         columns={columns} 
         dataSource={data as DataType[]}
         loading={loading}
         pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
         scroll={{ x: 'max-content', y: 580 }}
         locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
        />
       
      </div>
      <CusContent ref={dialog} save={handleSearch} fromPage="customerService" />
      <MerchantList ref={merchant} fromPage="customerService" />
      </>
  );
} 